import { fireEvent } from 'utils/analytics'
import { IPlanCart, setPlanCart } from 'utils/cart'

export const directivePaywallContinue = (planType: IPlanCart['type']) => {
  fireEvent('directive_paywall_continue', {
    option: 'plan_upgrade',
  })

  return setPlanCart({
    type: planType,
    firstSelectedType: planType,
  })
}
